import { t } from '@lingui/core/macro';
import { z } from 'zod';

export const EventTypeEnum = {
  MACHINE_ACTION: -1,
  PARTIAL_END: 0,
  ERROR: 1,
  DISPENSING: 2,
  PURGE: 3,
  CLEANING: 4,
  STIRRING: 5,
  MEASURING: 6,
  START: 7,
  SHUTDOWN: 8,
  SENSORS: 9,
  RECIRCULATION: 10,
  COLORANT_RESULT: 11,
  TEMPERATURE: 12,
  FLUSH: 13,
  REFILL: 14,
  BRUSH: 15,
  SW_START: 16,
  SW_SHUTDOWN: 17,
  TABLE_SLACK: 18,
} as const;

export const eventTypeSchema = z.enum(EventTypeEnum);

export type EventType = z.infer<typeof eventTypeSchema>;

export function getEventTypeLabel(eventType: EventType): string {
  switch (eventType) {
    case EventTypeEnum.MACHINE_ACTION:
      return t`Machine Action`;
    case EventTypeEnum.PARTIAL_END:
      return t`Partial End`;
    case EventTypeEnum.ERROR:
      return t`Error`;
    case EventTypeEnum.DISPENSING:
      return t`Dispensing`;
    case EventTypeEnum.PURGE:
      return t`Purge`;
    case EventTypeEnum.CLEANING:
      return t`Cleaning`;
    case EventTypeEnum.STIRRING:
      return t`Stirring`;
    case EventTypeEnum.MEASURING:
      return t`Measuring`;
    case EventTypeEnum.START:
      return t`Start`;
    case EventTypeEnum.SHUTDOWN:
      return t`Shutdown`;
    case EventTypeEnum.SENSORS:
      return t`Sensors`;
    case EventTypeEnum.RECIRCULATION:
      return t`Recirculation`;
    case EventTypeEnum.COLORANT_RESULT:
      return t`Colorant Result`;
    case EventTypeEnum.TEMPERATURE:
      return t`Temperature`;
    case EventTypeEnum.FLUSH:
      return t`Purge`;
    case EventTypeEnum.REFILL:
      return t`Refill`;
    case EventTypeEnum.BRUSH:
      return t`Brush`;
    case EventTypeEnum.SW_START:
      return t`SW Start`;
    case EventTypeEnum.SW_SHUTDOWN:
      return t`SW Shutdown`;
    case EventTypeEnum.TABLE_SLACK:
      return t`Table Slack`;
    default:
      return t`Unknown`;
  }
}
